import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import moment from 'moment'

pdfMake.vfs = pdfFonts.pdfMake.vfs

const { REACT_APP_BACKEND_URL } = process.env

// ── Helpers ───────────────────────────────────────────────────────────────────

const toBase64 = (url, headers = {}) =>
  fetch(url, { headers })
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror  = reject;
          reader.readAsDataURL(blob);
        })
    );

// ─────────────────────────────────────────────────────────────────────────────

class FormDokumentasiOpname extends Component {

  downloadDokumentasi = async () => {
    this.setState({ isLoading: true })

    const { dataExp } = this.props.report

    const firstItem = dataExp?.[0] || {}
    const noStock   = firstItem.no_stock || ''

    // ── Load semua gambar dulu (parallel) ────────────────────────────────────
    // Sama seperti Excel: cek image dulu, fallback ke pict array
    const imagePromises = dataExp.map(async (item) => {
      const cekPict = item.image !== null && item.image !== ''
      const pict    = cekPict
        ? item.image
        : (item.pict && item.pict.length > 0 ? item.pict[item.pict.length - 1].path : '')

      if (!pict || pict === '') return null

      try {
        const token = localStorage.getItem('token')
        const base64 = await toBase64(`${REACT_APP_BACKEND_URL}/${pict}`, 
          { Authorization: `Bearer ${token}` }
        )
        return base64
      } catch (e) {
        console.warn(`Gambar gagal dimuat untuk ${item.no_asset}:`, e)
        return null
      }
    })

    const images = await Promise.all(imagePromises)

    // ── Header tabel ──────────────────────────────────────────────────────────
    const tableHeader = [
      { text: 'NO',        bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'NO. ASET',  bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'DESKRIPSI', bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'PLANT',     bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'AREA',      bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'SATUAN',    bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'KONDISI',   bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'LOKASI',    bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'GROUPING',  bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'PICTURE',   bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
    ]

    // ── Rows data + gambar ────────────────────────────────────────────────────
    const tableRows = dataExp.map((item, index) => {
      const imgBase64 = images[index]

      // Cell gambar: kalau ada image embed, kalau tidak tampil '-'
      const pictCell = imgBase64
        ? {
            image:  imgBase64,
            width:  130,
            height: 100,
            alignment: 'center',
            border: [true, true, true, true],
            margin: [2, 4, 2, 4],
          }
        : {
            text:      '-',
            alignment: 'center',
            border:    [true, true, true, true],
            fontSize:  7,
            margin:    [0, 40, 0, 40],
          }

      return [
        { text: String(index + 1),                                        alignment: 'center', border: [true,true,true,true], fontSize: 7 },
        { text: item.no_asset   === null ? '-' : `${item.no_asset}`,      alignment: 'center', border: [true,true,true,true], fontSize: 7 },
        { text: item.deskripsi  === null ? '-' : `${item.deskripsi}`,     alignment: 'left',   border: [true,true,true,true], fontSize: 7 },
        { text: item.kode_plant === null ? '-' : `${item.kode_plant}`,    alignment: 'center', border: [true,true,true,true], fontSize: 7 },
        { text: item.area       === null ? '-' : `${item.area}`,          alignment: 'center', border: [true,true,true,true], fontSize: 7 },
        { text: item.satuan     === null ? '-' : `${item.satuan}`,        alignment: 'center', border: [true,true,true,true], fontSize: 7 },
        { text: item.kondisi    === null ? '-' : `${item.kondisi}`,       alignment: 'center', border: [true,true,true,true], fontSize: 7 },
        { text: item.lokasi     === null ? '-' : `${item.lokasi}`,        alignment: 'center', border: [true,true,true,true], fontSize: 7 },
        { text: item.grouping   === null ? '-' : `${item.grouping}`,      alignment: 'center', border: [true,true,true,true], fontSize: 7 },
        pictCell,
      ]
    })

    // ── Doc definition ────────────────────────────────────────────────────────
    const docDefinition = {
      pageSize:        'A4',
      pageOrientation: 'landscape',
      pageMargins:     [25, 25, 25, 30],

      footer: (currentPage, pageCount) => ({
        text:      `Halaman ${currentPage} dari ${pageCount}`,
        alignment: 'center',
        fontSize:  7,
        margin:    [0, 8, 0, 0],
      }),

      content: [

        // ── Judul ─────────────────────────────────────────────────────────────
        {
          text:       `DOKUMENTASI ASSET STOCK OPNAME ${noStock}`,
          bold:       true,
          fontSize:   12,
          decoration: 'underline',
          margin:     [0, 0, 0, 12],
        },

        // ── Tabel data + gambar ───────────────────────────────────────────────
        {
          table: {
            headerRows:         1,
            dontBreakRows:      true,
            keepWithHeaderRows: 1,
            widths:     ['auto', 50, '*', 30, 45, 25, 30, 35, 40, 140],
            body:       [tableHeader, ...tableRows],
          },
          layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
            paddingTop:    (i) => (i === 0 ? 3 : 4),
            paddingBottom: (i) => (i === 0 ? 3 : 4),
          },
        },
      ],

      defaultStyle: {
        fontSize: 8,
        font:     'Roboto',
      },
    }

    const fileName = `Dokumentasi Asset Stock Opname ${noStock} ${moment().format('DD MMMM YYYY')}.pdf`

    return new Promise((resolve, reject) => {
      try {
        pdfMake.createPdf(docDefinition).download(fileName, () => {
          this.setState({ isLoading: false })
          resolve(fileName)
        })
      } catch (err) {
        this.setState({ isLoading: false })
        reject(err)
      }
    })
  }

  render() {
    return (
      <Button
        color="info"
        onClick={this.downloadDokumentasi}
      >
        Download Dokumentasi PDF
      </Button>
    )
  }
}

const mapStateToProps = (state) => ({
  report:   state.report,
  user:     state.user,
  tempmail: state.tempmail,
  newnotif: state.newnotif,
})

export default connect(mapStateToProps)(FormDokumentasiOpname)